import type { Brand } from 'apis/enterprise/types';
import { Purchase } from 'apis/restaurant-api/merchant-admin/purchases/types';
import type { Venue } from 'apis/restaurant-api/merchant-admin/venue/types';

export const ALL_PERIODS = ['yesterday', 'this-week', 'last-week', 'this-month', 'last-month', 'custom'] as const;

export type Period = (typeof ALL_PERIODS)[number];

export type PreDefinedPeriod = Exclude<Period, 'custom'>;

export type DateRange = { from: Date; to: Date };

export type DateQuery = Date | null | undefined;

export type BrandVenues = {
  brand: Brand;
  venues: Venue[];
};

export type PurchaseWithBrandName = Purchase & {
  brandName?: string;
};

export type VenueWithBrandName = Venue & {
  brandName?: string;
};
